export default __webpack_public_path__ + "images/dd0e11b8838d4a7f948bc20864d4c866.png";